/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HammerPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABeklEQVR4nL2VuU7DQBBAjQQNhAYqRBlRUVDwASkgNPYcQdrMhKOhMC3Q0EITCSktNR/AH0CBFI5/4B8CJRKHCFqjCOMc3k0CI41kS7vveWd210HgFxPMUjTGFIJxByLOAus1sraB9CkiWRsbvFzemQHWGwvvJJC+IFbXR4YbYwpIcpuGZyVAempXF4Zm0RsOrM1e8JTkI/X8WKlsLzgLkOV8ELx3SsNdQPLgAweSFoAuOwuIavt+giEaDyTH/yE58ZV4nxPwlkjLnp8/lTBLMReKJHVkvSiVSpO9JED6CqQHxpg5m8hyBCRvSHJl7y4XeDsBsVzGcTzVJUE9zM4LN2tLURRND4azNLqWTVLPlot5dz55Z723V0puSfrBgaQVVqor6XERy8bPnO9x+fBUWVLH/5l5a3XwRzkIhoU7CVzL0omk5nlbtdMTZDnzgdvo94/4xWBtBnbrIeu7D9y7RMASI+vnsPDArQe6h6R3w8CdBKOG7UlS80x8AWV+yUD0UIDPAAAAAElFTkSuQmCC)
 */
export const HammerPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1ZM1.23 21.13a1 1 0 0 1 0-1.41l7.48-7.48c.2-.2.5-.2.7 0l2.13 2.12c.2.2.2.52 0 .71l-7.48 7.48a1 1 0 0 1-1.41 0l-1.42-1.42Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M21.3 13.07c.21.26.62.32.86.08l.45-.44a2 2 0 0 0 0-2.83l-2.94-2.94.65-.66a1 1 0 0 0 0-1.41l-1.41-1.42a1 1 0 0 0-1.41 0l-.66.66-2.72-2.72a2 2 0 0 0-2.83 0L7.76 4.93a2 2 0 0 0 0 2.83l7.53 7.53c.26.26.71.08.71-.29a3 3 0 0 1 5.3-1.93Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
